import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminGuard } from './guards/admin.guard';
import { UserGuard } from './guards/user.guard';
import { AdminAgencyGuard } from './guards/admin-agency.guard';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AdminGuard, UserGuard, AdminAgencyGuard],
})
export class CoreModule {}
